import * as z from "zod";

export const notifyMarketplace = {
  name: "notifyMarketplace" as const,
  input: z.object({ fulfillmentGroupId: z.string() }),
  output: z.object({ success: z.boolean() }),
};
